//component/MFASetupModal.js
import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Form, Modal, Row } from "react-bootstrap";
import { Button } from "../common/Button";
import { useDispatch } from "react-redux";
import { Key } from "@mui/icons-material";
import { startLogin } from "../webauthn";
import { is } from "date-fns/locale";

const PasskeyLogin = ({userId,orgId,username,password, handleClose,modalShow }) => {

    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    const handlePasskeyLogin = async () => {
        setIsLoading(true);
        const options = await startLogin(userId, orgId, username, password, dispatch);
    }


    return(
        <Modal
            size="lg"
            show={modalShow}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName
            backdrop={"static"}
            centered
            className="custom-dialog popup-org"
        >
            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter" className="text-center w-100">
                    Passkey Login
                </Modal.Title>
            </Modal.Header>
            
            <Modal.Body>
                <div>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <Key style={{ fontSize: "100px", color: "#005da8" }} />
                        <h4>Cross-Platform Passkey</h4>
                        <text>Example: YubiKey</text>
                
                    </div>
                    <div className="action-wrap mt-3">
                        <Button onClick={handlePasskeyLogin} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} /> : "Login with Passkey"}
                        </Button>
                        <Button onClick={handleClose} variant="secondary" className="ms-2">
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
        
    )
}

export default PasskeyLogin;